import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CoverageAppState from "../interfaces/CoverageAppState";
import { CoverageService } from "../../../services/coverageService";
import { actionCreators } from "../redux/actions";
import Category from "../interfaces/Category";
import CategoryItem from "../interfaces/CategoryItem";
import TabName from "../interfaces/TabName";
import {
  FullyChecked,
  NotChecked,
  ParentCategoryInput,
  PartiallyChecked,
} from "./ParentCategoryInput";
import { ParentCategoryExpanded } from "../interfaces/ParentCategoryExpanded";

export interface CategoriesList {
  expandedParentCategories: ParentCategoryExpanded[];
  setExpandedParentCategories: (
    newParentCategories: ParentCategoryExpanded[]
  ) => void;
  setNumberOfFollowedCategories: (number: number)=> void;
    onCloseCallback: () => void;
    visibleTabName: any;
}

const CategoriesList = ({
  visibleTabName,
  expandedParentCategories,
  setExpandedParentCategories,
  setNumberOfFollowedCategories,
  onCloseCallback,
}: CategoriesList) => {
  const service = new CoverageService();
  const dispatch = useDispatch();
  const categories = useSelector((state: CoverageAppState) => state.categories);
  let isLoading = false;

  const [myNumber, setMynumber] = React.useState<number>();

  const closeButtonRef = useRef(null);

  useEffect(() => {
     if (visibleTabName == TabName.ByCategory) {
         closeButtonRef.current.focus();
     }
  }, [visibleTabName]);

    useEffect(() => {
        getLengthOfFollowedItems();
    }, []);

  if (isLoading) {
    return <div className="notes-loader">laddar</div>;
  }

  if (categories.length === 0) {
    return (
      <div className="coverages__list-item coverages__list-item--padding-y">
        Hittade inga kategorier
      </div>
    );
  }

  const toggleParentFollowing = async (item: Category) => {
    const parent = item.parentCategory;
    const isAllChildrenChecked = item.childrenCategories.every(
      (x) => x.following
    );


    if (isAllChildrenChecked && !parent.isStandAlone) {
      await service.deleteWatchOfParentCategory(
        parent.categoryId,
        null!,
        (res) => console.error(res)
      );
    } else if (parent.following) {
      if (!parent.isStandAlone && !isAllChildrenChecked) {
        await service.addWatchOfParentCategory(
          parent.categoryId,
          null!,
          (res) => console.error(res)
        );
      } else if (parent.isStandAlone) {
        await service.deleteWatchOfCategory(parent.id, null!, (res) =>
          console.error(res)
        );
      } else {
        await service.deleteWatchOfParentCategory(
          parent.categoryId,
          null!,
          (res) => console.error(res)
        );
      }
    } else if (!parent.following) {
      if (parent.isStandAlone) {
        await service.addWatchOfCategory(parent.categoryId, null!, (res) =>
          console.error(res)
        );
      } else {
        await service.addWatchOfParentCategory(
          parent.categoryId,
          null!,
          (res) => console.error(res)
        );
      }
    }

    fetchAllCategories();
  };

  const toggleChildFollowing = async (childCategory: CategoryItem) => {
    if (childCategory.following) {
      await service.deleteWatchOfCategory(
        childCategory.id,
        () => fetchAllCategories(),
        (res) => console.error(res)
      );
    } else {
      await service.addWatchOfCategory(
        childCategory.categoryId,
        () => fetchAllCategories(),
        (res) => console.error(res)
      );
    }
  };

  const fetchAllCategories = () => {
    service.getCoverageCategories(
      (res) => {
        dispatch(actionCreators.setAllCategories(res));
      },
      (res) => console.error(res)
    );
  };

  const toggleSublist = (item: CategoryItem) => {
    const existingParent = expandedParentCategories.find(
      (x) => x.categoryId === item.categoryId
    );
    if (existingParent) {
      const newParentArray = [...expandedParentCategories].filter(
        (x) => x.categoryId !== item.categoryId
      );
      setExpandedParentCategories(newParentArray);
    } else {
      const newParentcategory: ParentCategoryExpanded = {
        categoryId: item.categoryId,
      };
      const newParentArray = [...expandedParentCategories, newParentcategory];
      setExpandedParentCategories(newParentArray);
    }
  };

  const getParentCategoryInputStatus = (currentCategory: Category): string => {
    if (currentCategory.parentCategory.isStandAlone) {
      return currentCategory.parentCategory.following
        ? FullyChecked
        : NotChecked;
    } else if (currentCategory.childrenCategories.every((x) => x.following)) {
      return FullyChecked;
    } else if (currentCategory.childrenCategories.every((x) => !x.following)) {
      return NotChecked;
    } else {
      return PartiallyChecked;
    }
  };

  function getLengthOfFollowedItems() {
    let number = 0;
    categories.map((item)=>{
      const numberOfCheckedChildren = item.childrenCategories.filter(
        (item) => item.following === true
      );
      number += numberOfCheckedChildren.length;
    });
    setNumberOfFollowedCategories(number);
    setMynumber(number);
  }

  return (
      <div
          className="coverages__list-wrapper personal__subnavigation active semiModal"
          role="dialog"
          aria-modal="true">
      <div className="coverages__header">
              <span>Du bevakar {myNumber} kategorier</span><button className="closeButton smaller" ref={closeButtonRef} onClick={onCloseCallback} aria-label="Stäng kategorier"><span>Stäng kategorier</span></button>
      </div>
      {categories.map((item) => {
        let parentStatus: string = getParentCategoryInputStatus(item);
        let parentIsExpanded: boolean = false;
        const totalNumberOfChild = item.childrenCategories.length;
        const numberOfCheckedChildren = item.childrenCategories.filter(
          (item) => item.following === true
        );

        if (expandedParentCategories) {
          const expandedParentCategory = expandedParentCategories.find(
            (category) => category.categoryId === item.parentCategory.categoryId
          );
          if (expandedParentCategory) parentIsExpanded = true;
        }
        return (
          <div key={item.parentCategory.categoryId}>
            <button
              className="coverages__item coverages__item--parent"
              aria-expanded={parentIsExpanded}
              onClick={() => {
                toggleSublist(item.parentCategory);
              }}
            >
              <ParentCategoryInput
                currentStatus={parentStatus}
                parentOnClick={(e: React.PointerEvent) => {
                  e.stopPropagation();
                  toggleParentFollowing(item);
                }}
              />

              {!item.parentCategory.isStandAlone ? (
                <>
                  <span className="coverages__parent-header">
                    <span className="coverages__parent-title">
                      {`${item.parentCategory.displayName}`}
                    </span>
                    <span className="coverages__parent-summary">
                      {`(${numberOfCheckedChildren.length} av ${totalNumberOfChild})`}
                    </span>
                  </span>
                  <strong
                    className="coverages__toggle-sublist"
                    onClick={() => toggleSublist(item.parentCategory)}
                  >
                    <span>Fäll ut</span>
                  </strong>
                </>
              ) : (
                <span className="coverages__parent-header">
                  <span className="coverages__parent-title longer">
                    {`${item.parentCategory.displayName}`}
                  </span>
                </span>
              )}
            </button>
            {!!item.childrenCategories.some && (
              <ol className="coverages__sublist-wrapper">
                {item.childrenCategories.map((subitem) => (
                  <li key={subitem.categoryId}>
                    <div className="coverages__item coverages__item--select" >
                      <label className="coverages__select-item">
                        <input
                          type="checkbox"
                          className="coverages__select-checkbox"
                          defaultChecked={subitem.following}
                        />
                        <span
                            className={`${subitem.following ? "checked" : ""}`}
                            tabIndex={0}
                            onClick={() => { toggleChildFollowing(subitem) }}
                            onKeyUp={(e) => { e.key === "Enter" && toggleChildFollowing(subitem) }}>
                            {subitem.displayName}, {subitem.following ? "vald" : "inte vald"}
                        </span>
                        <div
                            className="coverages__label-name"
                            onClick={() => { toggleChildFollowing(subitem) }}
                            onKeyUp={(e) => { e.key === "Enter" && toggleChildFollowing(subitem) }}>
                            {subitem.displayName}
                        </div>
                      </label>
                      
                    </div>
                  </li>
                ))}
              </ol>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CategoriesList;
